// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_4w-6";
export var headerCell = "_4w-2";
export var rowWrapper = "_4w-4";
export var stickyAggregationCell = "_4w-a";
export var stickyAggregationRow = "_4w-7";
export var stickyColumnCell = "_4w-9";
export var stickyColumnHeaderCell = "_4w-8";
export var table = "_4w-1";
export var virtualRowWrapper = "_4w-5";
export var virtualTableContainer = "_4w-0";
export var white = "_4w-3";